export default {
    methods: {
        updateParams(newProps, paramName = 'serverParams') {
            this[paramName] = Object.assign({}, this[paramName], newProps);
        },
        onPageChange(params, dataFetcher = 'paginatedData') {
            this.updateParams({page: params.currentPage});
            this[dataFetcher]();
        },
        onPerPageChange(params, dataFetcher = 'paginatedData') {
            this.updateParams({perPage: params.currentPerPage});
            this[dataFetcher]();
        },
        serialNo(props, paramName = 'serverParams') {
            return this[paramName].page === 1 ? props.index + 1 : (this[paramName].perPage *
                    (this[paramName].page - 1)) +
                props.index + 1
        },
    }
}
